import { Component, input } from '@angular/core';

@Component({
  selector: 'app-btn-submit',
  standalone: true,
  templateUrl: './btn-submit.component.html',
  styleUrls: ['./btn-submit.component.css'],
})
export class BtnSubmitComponent {
  actionText = input<string>('Submit');
  isDisabled = input<boolean>(false);
  isLoading = input<boolean>(false);
  fullWidth = input<boolean>(false);
  padding = input<string>('px-4 py-2');
  bgColor = input<string>(
    'bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-gray-200',
  );
  icon = input<string>();
  suffixIcon = input<string>('');

  constructor() {}
}
